import _classCallCheck from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
// eslint-disable-next-line no-restricted-syntax
export var AbstractLifeCycle = /*#__PURE__*/function () {
  function AbstractLifeCycle() {
    _classCallCheck(this, AbstractLifeCycle);
    this.callbacks = {};
  }
  return _createClass(AbstractLifeCycle, [{
    key: "notify",
    value: function notify(eventType, data) {
      var eventCallbacks = this.callbacks[eventType];
      if (eventCallbacks) {
        eventCallbacks.forEach(function (callback) {
          return callback(data);
        });
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(eventType, callback) {
      var _this = this;
      if (!this.callbacks[eventType]) {
        this.callbacks[eventType] = [];
      }
      this.callbacks[eventType].push(callback);
      return {
        unsubscribe: function unsubscribe() {
          _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) {
            return callback !== other;
          });
        }
      };
    }
  }]);
}();